import React from 'react';
import { useI18n, usePageTitle } from '../../i18n/index.jsx';
import PageHero from '../../components/PageHero.jsx';
import { CONTACT_EMAIL } from './Contact.jsx';

// Privacy policy and Terms share this layout; their text lives in the
// i18n files under privacy.* and terms.* (placeholder until replaced).
// Update UPDATED[doc] whenever a document's text changes.
const UPDATED = { privacy: '2026-10-26', terms: '2026-10-10' };

function LegalPage({ doc }) {
  const { t, tm, lang } = useI18n();
  usePageTitle(`${doc}.title`);
  const date = new Date(`${UPDATED[doc]}T12:00:00`).toLocaleDateString(lang === 'en' ? 'en-CA' : 'fr-CA', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <>
      <PageHero title={t(`${doc}.title`)}>
        <p className="page-hero-meta">{t('legal.updated', { date })}</p>
      </PageHero>
      <section className="section">
        <div className="container">
          <div className="legal">
          <p className="legal-placeholder">{t('legal.placeholder')}</p>
          <p className="legal-intro">{t(`${doc}.intro`)}</p>
          {tm(`${doc}.sections`).map((s) => (
            <section key={s.h}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </section>
          ))}
          <p className="muted">{t('legal.contactLine')}<a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
          </div>
        </div>
      </section>
    </>
  );
}

export const Privacy = () => <LegalPage doc="privacy" />;
export const Terms = () => <LegalPage doc="terms" />;
